import { Route } from 'react-router-dom'

import CheckoutPage from 'Components/Pages/CheckoutPage'
import QRPaymentPage from 'Components/Pages/QRPaymentPage'
import TaxInvoice from 'Components/Elements/Checkout/ShippingAddressForm/Country/Thailand/TaxInvoice/TaxInvoice'
import PaymentResponseSuccess from 'Components/Pages/PaymentResponseSuccess'
import PaymentResponseFailed from 'Components/Pages/PaymentResponseFailed'
import PaymentResponseDone from 'Components/Pages/PaymentResponseDone'

const CheckoutRoutes = ({ withLoginWrapper }) => [
    <Route key="checkout" path="/checkout" element={withLoginWrapper(<CheckoutPage />)} />,
    <Route key="checkout-step" path="/checkout/:step" element={withLoginWrapper(<CheckoutPage />)} />,
    <Route key="qr-payment" path="/qr/payment" element={<QRPaymentPage />} />,
    <Route key="tax-invoice" path="tax-invoice" element={<TaxInvoice />} />,
    <Route key="payment-success" path="/payment-response/success" element={<PaymentResponseSuccess />} />,
    <Route key="payment-failed" path="/payment-response/failed" element={<PaymentResponseFailed />} />,
    <Route key="payment-done" path="/payment-response/done" element={<PaymentResponseDone />} />
]

export default CheckoutRoutes

